import { Attachment } from 'services/chat';
import { MessageContent, MessageContentType } from './messageContent';
import { ChatUser, MessageSendStatus, MessageStatus } from './types';

export class Message {
	id: string;

	author: string;

	authorDto: ChatUser;

	channelId: string;

	contents: MessageContent[];

	attachments: Attachment[];

	replyTo?: string;

	reactions?: Map<string, string[]>; // emoji -> userIds

	sendStatus: MessageSendStatus;

	messageStatus: MessageStatus;

	createDate: Date;

	editDate?: Date;

	constructor(
		id: string,
		author: string,
		channelId: string,
		contents: MessageContent[],
		createDate: number,
		authorDto: ChatUser,
		sendStatus: MessageSendStatus,
		messageStatus: MessageStatus,
		replyTo?: string,
		reactions?: Map<string, string[]>,
		editDate?: number
	) {
		this.id = id;
		this.author = author;
		this.channelId = channelId;
		this.contents = contents || [];
		this.createDate = new Date(createDate * 1000);
		this.attachments = [];
		this.authorDto = authorDto;
		this.replyTo = replyTo;
		this.reactions = reactions;
		this.sendStatus = sendStatus;
		this.messageStatus = messageStatus;
		this.editDate = editDate ? new Date(editDate * 1000) : undefined;
	}

	setAttachments(attachments: Attachment[]): this {
		this.attachments = attachments;
		return this;
	}

	getAllMentions(): string[] {
		return this.contents.flatMap((content) => content.mentions).map((mention) => mention.userId);
	}

	renderAsChannelLastMessage(): string {
		if (this.messageStatus === MessageStatus.Deleted) {
			return 'This message was deleted';
		}

		const firstContent = this.contents[0];
		if (!firstContent) return '';

		switch (firstContent.type) {
			case MessageContentType.Text:
			case MessageContentType.RichText:
				return firstContent.content;
			case MessageContentType.Image:
				return '📷 Image';
			case MessageContentType.Video:
				return '🎥 Video';
			case MessageContentType.Audio:
				return '🎵 Audio';
			case MessageContentType.File:
				return '📎 File';
			default:
				return firstContent.content;
		}
	}

	delete() {
		this.attachments = [];
		this.contents = [];
		this.messageStatus = MessageStatus.Deleted;
	}
}
